<template>
  <div class="mt-2">
    <h3 class="text-primary py-2 text-center">Clinical Placements and Trend Analysis Charts</h3>
    <CRow>
        <CCol md="6">
            <PlacementTypeChart />
        </CCol>
        <CCol md="6">
            <SpecialityChart />
        </CCol>
        <CCol md="6">
            <PreferredLocationChart />
        </CCol>
        <CCol md="6">
            <ApplicationStatusChart />
        </CCol>
    </CRow>
    <div>
      <CountrySpecificCount />
    </div>
  </div>
</template>
<script>
import PlacementTypeChart from "@/containers/ClinicalPlacementDashboard/PlacementTypeChart.vue";
import SpecialityChart from "@/containers/ClinicalPlacementDashboard/SpecialityChart.vue";
import PreferredLocationChart from "@/containers/ClinicalPlacementDashboard/PreferredLocationChart.vue";
import ApplicationStatusChart from "@/containers/ClinicalPlacementDashboard/ApplicationStatusChart.vue";
import CountrySpecificCount from "@/containers/ClinicalPlacementDashboard/CountrySpecificCount.vue";
export default {
  name: "ClinicalPlacementsDashboard",
  components: {
    PlacementTypeChart,
    SpecialityChart,
    PreferredLocationChart,
    ApplicationStatusChart,
    CountrySpecificCount,
  },
};
</script>
<style scoped></style>
